export const CollectionHeader = {
  bindings: {
    collection: '<',
    isLoading: '<',
  },

  template: `
    <div class="collection-header bg-white"
      ng-class="{ 'active': $ctrl.readMore }"
      ng-init="$ctrl.readMore = false">
      <div class="content-wrapper container py-3 pt-md-5">
        <div class="header-img bg-mask-overlay bg-mask-overlay--lg position-md-absolute">
          <image-background src="$ctrl.collection.coverImageUrl.magazine"></image-background>
        </div>
        <div class="row">
          <div class="col-md-8 collapse-left">
            <section class="pb-3">
              <header class="card-title mb-4">
                <divider-zig-zag>
                  <h3 class="h3 mt-2 mt-sm-0">
                    <spinner is-loading="$ctrl.isLoading">
                      {{ $ctrl.collection.title || 'Loading...' }}
                    </spinner>
                  </h3>
                </divider-zig-zag>
                <p class="lead">{{ $ctrl.collection.strapLine }}</p>
              </header>
              <div class="lead my-3 pt-3 border border-y border-green-mid text-green-mid"
                ng-bind-html="$ctrl.collection.skimHtml"
                ng-if="$ctrl.collection.skimHtml">
              </div>
              <div ng-bind-html="$ctrl.collection.theWhatHtml"></div>
              <div ng-bind-html="$ctrl.collection.theWhyHtml"></div>
            </section>
          </div>
          <div class="col-md-4 collapse-right pr-0">
            <section class="bg-green-light p-3"
              ng-bind-html="$ctrl.collection.theElseHtml">
            </section>
          </div>
        </div>
      </div>
      <div class="toggle-row"
        ng-class="{
          'bg-white': !$ctrl.readMore,
          'position-relative pt-0': $ctrl.readMore
        }">
        <div class="container">
          <button-link ng-click="$ctrl.readMore = !$ctrl.readMore">
            Read
            <span ng-if="!$ctrl.readMore">more <i class="fa fa-chevron-down"></i></span>
            <span ng-if="$ctrl.readMore">less <i class="fa fa-chevron-up"></i></span>
          </button-link>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Collection/CollectionHeader.js